<script lang="ts">
  import { tz_name } from './stores/CurrentDate.js';
  import { user_info } from './stores/User';
  import { installations } from './stores/Data';
</script>

<section class="section">
  {#if !$user_info.name }
    <p>Désolé, vous devez d'abord <a href="https://authentication.qotto.net/">vous connecter</a>.</p>
  {:else}
    <div class="content">
      <p>
        Bonjour, {$user_info.name} !
        <small>Cliquez <a href="https://authentication.qotto.net/logout">ici</a> pour vous déconnecter</small>.
      </p>
    </div>
    {#await installations}
      <p>Chargement…</p>
    {:then installations_list}
      <table class="table is-bordered is-striped is-hoverable">
        <thead>
          <tr>
            <th>
              <span class="icon-text">
                <span class="icon">
                  <i class="fas fa-file-contract"></i>
                </span>
                <span>Contrat</span>
              </span>
            </th>
            <th>
              <span class="icon-text">
                <span class="icon">
                  <i class="fas fa-charging-station"></i>
                </span>
                <span>BMS</span>
              </span>
            </th>
            <th>
              <span class="icon-text">
                <span class="icon">
                  <i class="fas fa-user-alt"></i>
                </span>
                <span>Client</span>
              </span>
            </th>
            <th>
              Début de contrat
            </th>
            <th>
              Payé jusqu'au
            </th>
            <th>
              <span class="icon-text">
                <span class="icon">
                  <i class="fas fa-percent"></i>
                </span>
                <span>Activation</span>
              </span>
            </th>
            <th>
              <span class="icon-text">
                <span class="icon">
                  <i class="fas fa-hand-holding-usd"></i>
                </span>
                <span>Retard</span>
              </span>
            </th>
            <th>
              <span class="icon-text">
                <span class="icon">
                  <i class="fas fa-chart-line"></i>
                </span>
                <span>Conso / Prod (Wh)</span>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {#each installations_list as install}
            <tr>
              <td><code>{install.contractNo.toString().padStart(6, '0')}</code></td>
              <td><tt>{install.bmsSn}</tt></td>
              <td>
                {#if install.country === 1}
                  🇧🇯
                {:else}
                  🇧🇫
                {/if}
                {install.clientName}
                {#if install.clientMomoNumber}
                  <a href="tel:{install.clientMomoNumber}">
                    <i class="fas fa-phone-volume"></i>
                  </a>
                {/if}
              </td>
              <td>
                {new Date(install.firstActivationDate * 60 * 1000).toLocaleDateString()}
              </td>
              <td>
                {new Date(install.expirationReqDate * 60 * 1000).toLocaleDateString()}
              </td>
              <td>{install.activationRate} %</td>
              <td>{install.amountToRecover} ₣</td>
              <td>{install.avgPow7dCons} / {install.avgPow7dProd}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    {:catch e}
      <p>Rien à afficher…</p>
    {/await}
  {/if}
</section>
<footer class="footer">
  <div class="content has-text-centered">
    <p>
      Les dates sont affichées avec le fuseau horaire
      <strong>{$tz_name}</strong>.
    </p>
    <p>
      <small>
        Copyright © <strong>Qotto</strong> {new Date().getFullYear()}
        —
        Application strictement confidentielle, usage interne uniquement.
      </small>
    </p>
  </div>
</footer>
<style>
</style>
